/** @format */

import { ConfigService, configServiceFactory } from './config.service';
import { ProblemsService } from './problems/problems.service';
import { ActivityService } from './activities/activities.service';
import { AssetService } from './assets/asset.service';
import { HttpErrorHandler } from './http-error-handler.service';
import { MessageService } from './message.service';
import { LayersService } from './layers/layers.service';
import { LocationService } from './location/location.service';
import { SearchService } from './search/search.service';
import { WorkOrderService } from './WorkOrder/workOrder.service';
import { ArcGisService } from './arcgis.service';
import { AdminService } from './admin/admin.service';
import { CityworksService } from './cityworks/cityworks.service';

export const services: any[] = [
	{ provide: ConfigService, useFactory: configServiceFactory() },
	ProblemsService,
	ActivityService,
	AssetService,
	HttpErrorHandler,
	MessageService,
	LayersService,
	LocationService,
	SearchService,
	WorkOrderService,
	ArcGisService,
	AdminService,
	CityworksService,
];

export * from './config.service';
export * from './problems/problems.service';
export * from './activities/activities.service';
export * from './http-error-handler.service';
export * from './message.service';
export * from './assets/asset.service';
export * from './layers/layers.service';
export * from './location/location.service';
export * from './search/search.service';
export * from './WorkOrder/workOrder.service';
export * from './arcgis.service';
export * from './admin/admin.service';
export * from './cityworks/cityworks.service';
